<script setup>
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

// Components
import AddOnLabel from '@/Components/AddOnLabel.vue';
import Button from '@/Components/Button/Button.vue';
import ServiceItem from './ServiceItem.vue';

const props = defineProps({
    title: String,
    services: Array,
    addOnLabel: Boolean,
    button_label: String,
    intended_url: String,
});

const moduleActive = computed(() => usePage().props.template_options.modules.service_component_active);
</script>

<template>
    <div class="container py-12 md:py-16" :class="{ 'relative  ': addOnLabel }" v-if="moduleActive">
        <AddOnLabel v-if="addOnLabel" />

        <h2 class="" v-html="title" v-if="title"></h2>

        <div class="grid gap-20 mt-6 md:grid-cols-2 lg:grid-cols-3 md:mt-0">
            <ServiceItem :item="item" v-for="(item, i) in services" :key="i" />
        </div>

        <Button v-if="button_label && intended_url" :is="'a'" :href="intended_url" :label="button_label"
            :target="page_id === null || page_id === undefined ? true : false" class="relative z-30 w-auto mt-8"></Button>
    </div>
</template>
